
import { Vue } from "vue-class-component";

export default class CycleTime extends Vue {}
